import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class OffersOptionsGuard implements CanActivate {

  constructor(private router: Router) { }

        canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): boolean {
    const hostname = window.location.hostname;
    const isOffersOptionsDomain = this.isOffersOptionsDomain(hostname);

    console.log(`OffersOptionsGuard: hostname=${hostname}, isOffersOptionsDomain=${isOffersOptionsDomain}, url=${state.url}`);

    // Handle offers-comparison route specifically
    if (state.url === '/offers-comparison') {
      if (isOffersOptionsDomain) {
        console.log('OffersOptionsGuard: Allowing access to offers-comparison on offers-options domain');
        return true; // Allow access to offers-comparison on offers-options domains
      } else {
        console.log('OffersOptionsGuard: Redirecting to dashboard (non-offers-options domain accessing offers-comparison)');
        this.router.navigate(['/dashboard']);
        return false;
      }
    }

    // Handle dashboard route (default route redirects to dashboard, so we intercept here)
    if (state.url === '/dashboard') {
      if (isOffersOptionsDomain) {
        console.log('OffersOptionsGuard: Redirecting to offers-comparison (offers-options domain accessing dashboard)');
        this.router.navigate(['/offers-comparison']);
        return false;
      } else {
        console.log('OffersOptionsGuard: Allowing normal navigation to dashboard (non-offers-options domain)');
        return true;
      }
    }

    // Handle other routes
    if (isOffersOptionsDomain) {
      console.log(`OffersOptionsGuard: Blocking access to ${state.url} on offers-options domain, redirecting to offers-comparison`);
      this.router.navigate(['/offers-comparison']);
      return false;
    }

    console.log(`OffersOptionsGuard: Allowing normal access to ${state.url} (non-offers-options domain)`);
    return true;
  }

  /**
   * Checks if the current domain is an offers-options domain
   */
  private isOffersOptionsDomain(hostname: string): boolean {
    // Remove port number if present for local development
    const cleanHostname = hostname.split(':')[0];
    return cleanHostname === 'offers-options-uat.revenued.com' ||
           cleanHostname === 'offers-options-local.revenued.com' ||
           cleanHostname === 'offers-options.revenued.com' ||
           cleanHostname === 'offers-options-uat.revenuedva.com' ||
           cleanHostname === 'offers-options-local.revenuedva.com' ||
           cleanHostname === 'offers-options.revenuedva.com';
  }
}
